import {
  GE_OWNED_APPLIANCE_BRANDS,
  brandNameIn,
} from "@ri2/db/outcomePolicy/brands"

export type RecommendationHostSource = "host" | "internal"

export type RecommendationHostPolicy = (context: {
  type: "proService" | "replace"
  brand?: string | null
}) => RecommendationHostSource

export type PartPurchaseHostPolicy = (
  brand?: string | null,
) => RecommendationHostSource

export const isGeOwnedApplianceBrand = (
  brand: string | null | undefined,
): boolean => brandNameIn(brand, GE_OWNED_APPLIANCE_BRANDS)

export const geRecommendationHostPolicy: RecommendationHostPolicy = ({
  type,
  brand,
}) => {
  if (type === "proService" && !isGeOwnedApplianceBrand(brand)) {
    return "internal"
  }
  return "host"
}

/** GE-family → host cart / PDP; other brands → catalog purchaseUrl. */
export const gePartPurchaseHostPolicy: PartPurchaseHostPolicy = (brand) =>
  isGeOwnedApplianceBrand(brand) ? "host" : "internal"

const RECOMMENDATION_POLICY_BY_AGENT_PROFILE: Record<
  string,
  RecommendationHostPolicy
> = {
  "agent-ge": geRecommendationHostPolicy,
}

const PART_PURCHASE_POLICY_BY_AGENT_PROFILE: Record<
  string,
  PartPurchaseHostPolicy
> = {
  "agent-ge": gePartPurchaseHostPolicy,
}

export const getRecommendationHostPolicyForAgentProfile = (
  profileId: string | null | undefined,
): RecommendationHostPolicy | null =>
  (profileId && RECOMMENDATION_POLICY_BY_AGENT_PROFILE[profileId]) || null

export const getPartPurchaseHostSourceForAgentProfile = (
  profileId: string | null | undefined,
  brand?: string | null,
): RecommendationHostSource | null => {
  const policy =
    (profileId && PART_PURCHASE_POLICY_BY_AGENT_PROFILE[profileId]) || null
  return policy ? policy(brand) : null
}
